import { render, staticRenderFns } from "./scorelog.vue?vue&type=template&id=9f1c89c6&scoped=true&"
import script from "./scorelog.vue?vue&type=script&lang=js&"
export * from "./scorelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1c89c6",
  null
  
)

export default component.exports